import { useEffect, useState } from 'react';
import { getMyModels } from '@/services';

interface AssetData {
  id: number,
  creator: number,
  url: string,
  createdAt: string,
}

const useFetchMyModel = () => {
  const [assetData, setAssetData] = useState<AssetData[]>([]);
  const [loading, setLoading] = useState(false);

  const handleGetModel = async () => {
    setLoading(true);
    const res = await getMyModels();
    setAssetData(res.data?.items || []);
    setLoading(false);
  };

  useEffect(() => {
    handleGetModel();
  }, []);

  return {
    assetData,
    loading,
    handleGetModel
  };
};

export default useFetchMyModel;
